import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'pos-observations-step',
  templateUrl: './observations-step.component.html',
  styleUrls: ['./observations-step.component.sass']
})
export class ObservationsStepComponent implements OnInit {

  @Input() observationForm: FormGroup = new FormGroup({
    observationText: new FormControl("")
  });
  @Input() readonly = false;
  constructor() { }

  ngOnInit(): void {

  }
}
